import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Mail, Phone } from "lucide-react";

const LABEL = { master: "Master", agency: "Agenzia" };

export function UplineLine({ user, prefix = "" }) {
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    if (user?.role !== "dealer") { setContacts([]); return; }
    api.get("/me/upline").then((r) => setContacts(r.data.contacts || [])).catch(() => setContacts([]));
  }, [user?.id, user?.role]);
  if (!contacts.length) return null;
  return (
    <div className="text-[11px] text-muted-foreground mt-1.5 grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-1.5 gap-y-0.5 leading-snug" data-testid={`${prefix}upline-line`}>
      {contacts.map((c) => (
        <React.Fragment key={c.kind}>
          <span>{LABEL[c.kind]}:</span>
          <Popover>
            <PopoverTrigger asChild>
              <button type="button" className="text-left truncate !min-h-0 underline decoration-dotted underline-offset-2 hover:text-foreground transition-colors" data-testid={`${prefix}upline-${c.kind}`}>{c.name}</button>
            </PopoverTrigger>
            <PopoverContent className="w-64 text-sm space-y-2" data-testid={`${prefix}upline-${c.kind}-card`}>
              <p className="text-xs uppercase tracking-wider text-muted-foreground">{c.kind === "master" ? "Il tuo master" : "La tua agenzia"}</p>
              <p className="font-medium">{c.name}</p>
              {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-2 hover:text-primary" data-testid={`${prefix}upline-${c.kind}-phone`}><Phone className="w-3.5 h-3.5" />{c.phone}</a>}
              {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 hover:text-primary break-all" data-testid={`${prefix}upline-${c.kind}-email`}><Mail className="w-3.5 h-3.5" />{c.email}</a>}
            </PopoverContent>
          </Popover>
        </React.Fragment>
      ))}
    </div>
  );
}
